<template>
  <div>
    <ol :class="{ 'show-all-promotions': showAllPromotions, 'entry-promotions': true }">
      <li v-for="promotion in promotions" :class="isTooFarInFuture(promotion) ? 'too-far' : ''" :key="promotion.start">
        <h1 v-if="headlineLevel === 1">{{ promotion.title }}</h1>
        <h2 v-if="headlineLevel === 2">{{ promotion.title }}</h2>
        <h3 v-if="headlineLevel === 3">{{ promotion.title }}</h3>
        <h4 v-if="headlineLevel === 4">{{ promotion.title }}</h4>

        <p class="date-range">
          <template v-if="showDateDiff(promotion)">
            <span class="date-diff">
              <template v-if="dateDiff(promotion) > 0">
                <template v-if="dateDiff(promotion) > 1">
                  Noch {{ dateDiff(promotion) }} Tage
                </template>
                <template v-else>
                  Vorletzer Tag
                </template>
              </template>
              <template v-else>
                Letzter Tag
              </template>
            </span>
            &nbsp;&ndash;&nbsp;
          </template>
          <template v-if="isSameYear(promotion)">
            <template v-if="isSameDay(promotion)">
              {{ promotion.start.format("D. MMMM YYYY") }}
            </template>
            <template v-else-if="isSameMonth(promotion)">
              {{ promotion.start.format("D.") }} bis {{ promotion.end.format("D. MMMM YYYY") }}
            </template>
            <template v-else>
              {{ promotion.start.format("D. MMMM") }} bis {{ promotion.end.format("D. MMMM YYYY") }}
            </template>
          </template>
          <template v-else>
            {{ promotion.start.format("D. MMMM YYYY") }} bis {{ promotion.end.format("D. MMMM YYYY") }}
          </template>
        </p>

        <p class="promotion-text">{{ promotion.text }}</p>
        <p class="promo-link ion-android-open" v-if="showHref(promotion)"><a :href="promotion.href" v-text="readableURL(promotion)" /></p>
      </li>
    </ol>
    <div v-if="hasFuturePromotions" class="show-future-promotions">
      <button class="button" @click="showAllPromotions = !showAllPromotions">
        <span v-if="showAllPromotions">Weniger </span>
        <span v-else>Weitere </span>
        Angebote anzeigen &hellip;
      </button>
    </div>
  </div>
</template>
<script>
  import * as moment from "moment";

  export default {
    name: "sk-entry-promotions",
    props: {
      promotions: {
        type: Array,
        required: true
      },
      headlineLevel: {
        type: Number,
        default: 3
      },
      defaultDaysIntoFuture: {
        type: Number,
        default: 7
      }
    },
    data () {
      return {
        now: moment(),
        showAllPromotions: false
      }
    },
    computed: {
      hasFuturePromotions() {
        return this.promotions.some(this.isTooFarInFuture);
      }
    },
    methods: {
      showHref(promotion) {
        return promotion.href && /^https?:\/\/.+$/.test(promotion.href);
      },
      readableURL(promotion) {
        try {
          return new URL(promotion.href).hostname;
        } catch (e) {
          return promotion.href;
        }
      },
      showDateDiff(promotion) {
        return this.now.isSameOrAfter(promotion.start) && promotion.end.diff(this.now, "days") <= 3;
      },
      dateDiff(promotion) {
        return promotion.end.diff(this.now, "days");
      },
      isSameYear(promotion) {
        return promotion.start.year() === promotion.end.year();
      },
      isSameMonth(promotion) {
        return promotion.start.isSame(promotion.end, "month");
      },
      isSameDay(promotion) {
        return promotion.start.isSame(promotion.end, "day");
      },
      isTooFarInFuture(promotion)  {
        return promotion.start.isAfter(moment().add(this.defaultDaysIntoFuture, "day"), "day");
      }
    }
  }
</script>
<style lang="scss" scoped>
  .entry-promotions {
    margin: 0 0 3.125rem 0;
    padding: 0;
    list-style: none;

    h1,
    h2,
    h3,
    h4,
    p {
      margin: 0;
    }

    .date-range {
      margin: 0.125rem 0 0.25rem 0;
      color: #646464;

      .date-diff {
        color: #000;
      }
    }

    .promotion-text {
      line-height: 1.25rem;
    }

    .promo-link {
      margin-top: 0.25rem;

      &::before {
        font-size: 0.875rem;
        color: #3e5b33;
        margin-right: 0.375rem;
      }
    }

    &:not(.show-all-promotions) .too-far {
      display: none;
    }

    li + li {
      margin-top: 1.75rem;
    }

    & + .show-future-promotions {
      display: flex;
      justify-content: space-around;
      margin: -2rem 0 3.125rem 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EntryPromotions.vue